export default {
    SPRITE: 'sprite',
    BACKDROP: 'backdrop',
    COSTUME: 'costume',
    SOUND: 'sound',
    EXTENSION: 'extension',
    TIP: 'tip'
};